import ConversationDto from './ConversationDto';

export default class WorkerConversationsViewModel {
    selectedConversationId = "";
    selectedConversation: ConversationDto = new ConversationDto();
}